module.exports = __webpack_public_path__ + "static/media/mgo4.f6da2779.png";